export default class MessagePolicy {
    constructor(gate) {
        this.gate = gate;
    }

    browse(user, document) {
        return user.isAuthor
            || this.gate.allow('read', 'document', document);
    }

    add(user, document) {
        return true;
    }

    read(user, message, document) {
        return user.isAuthor
            || this.gate.allow('read', 'document', document);
    }

    reply(user, message, document) {
        return user.isAuthor || this.gate.allow('read', 'document', document);
    }

    flagAsUnread(user, message, document) {
        return message.is_open
            && message.to_staff
            && user.isStaff
            && user.interactsWithQueue(message.queue)
            && this.gate.allow('read', 'document', document);
    }
}
